"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.orderRange = void 0;
const scale_1 = require("../../1d/utilities/scale");
function orderRange(start, end) {
    const range = [0, 0];
    if (start > end) {
        range[0] = end;
        range[1] = start;
    }
    else {
        range[0] = start;
        range[1] = end;
    }
    return range;
}
exports.orderRange = orderRange;
function getRange(draft, options) {
    const { startX, endX } = options;
    const scaleX = (0, scale_1.getXScale)(draft);
    const start = scaleX.invert(startX);
    const end = scaleX.invert(endX);
    return orderRange(start, end);
}
exports.default = getRange;
